import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import Widget from "./Widget";
import useHorecaWidget from "../../hooks/useHorecaWidget";
import { useTheme } from "@emotion/react";

dayjs?.extend(customParseFormat);

const HorecaWidget = ({ floating, widgetpos }) => {
  const theme = useTheme();

  const {
    isOpenWidget,
    send,
    handleClose,
    widgetConfig,
    widgetLoading,
    openWidget,
    setOpenWidget,
    dispatch,
    buttonText,
    getWidgetPositionStyle,
    combinationLoading,
    reservTypeLoading,
    langLoading,
  } = useHorecaWidget();

  const hasImage           = Boolean(widgetConfig?.settings?.imageFileName?.trim());
  const configuredImgHeight = widgetConfig?.settings?.imageHeight;
  const [dynamicHeight, setDynamicHeight] = useState(undefined);

  const handleHeightChange = (heightPx) => {
    if (!hasImage) setDynamicHeight(heightPx);
  };

  const iframeHeight = hasImage
    ? configuredImgHeight ? `${configuredImgHeight}px` : "100vh"
    : dynamicHeight ?? "100vh";

  const widgetData = {
    isOpenWidget,
    send,
    handleClose,
    widgetConfig,
    theme,
    widgetLoading,
    openWidget,
    setOpenWidget,
    dispatch,
    buttonText,
    getWidgetPositionStyle,
    combinationLoading,
    reservTypeLoading,
    widgetpos,
  };

  if (widgetLoading || langLoading) {
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={widgetLoading || langLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (widgetConfig?.settings?.kioskMode) {
    return (
      <Box sx={{ width: "100%", minHeight: "100vh" }}>
        <Widget
          data={widgetData}
          heightChange={handleHeightChange}
          handleClose={() => setOpenWidget((prev) => !prev)}
        />
      </Box>
    );
  }

  return (
    <>
      {send(iframeHeight, "100vw", "0px", "0px", "0px", "", "relative")}
      <Box
        sx={{
          width: "100%",
          height: iframeHeight,
          position: "relative",
          // overflow must be visible so popovers that extend below the widget
          // aren't clipped while the height is still being measured.
          overflow: "visible",
        }}
      >
        <Widget
          data={widgetData}
          heightChange={handleHeightChange}
          handleClose={() => setOpenWidget((prev) => !prev)}
        />
      </Box>
    </>
  );
};

export default HorecaWidget;
